import type { FaireProductEntity } from "../../entity_types/product";

export const p_j3ka8xdr3q: FaireProductEntity = {
  token: "p_j3ka8xdr3q",
  type: "product",
  name: "Skeleton Halloween Fall Whiskey Glass | Single | 10oz",
  brandToken: "b_cb4uov1t42",
  brandName: "The Wine Savant /  Khen Glassware",
  imageUrl:
    "https://cdn.faire.com/fastly/524a6dc1feb49387729c2208b7548ff9548c9bcc7378e5487dd000af868e48c6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4c37793c47222375bfb909b9b3da56b9cda57eeb7667b22594c716648015baf.jpeg",
    "https://cdn.faire.com/fastly/1f2f01a01dd9849b592fd407ae393548564c2e1af057a887de6a5cf4dc171481.jpeg",
    "https://cdn.faire.com/fastly/16e3fe83546a42767043686c991a180fca292b01dbecbbb57c8684b002741934.jpeg",
    "https://cdn.faire.com/fastly/5e38a483301731c49023dac162b33f40dff638f3b37fed4c2408f379c252b11b.jpeg",
    "https://cdn.faire.com/fastly/2177c6cbe6bfadee02737947ff97871b014c7be7b49873e6a7186eab23126fc0.jpeg",
  ],
  priceDollars: 11,
  description:
    "The Skeleton Whiskey Glass is a chillingly captivating addition to your barware collection, making it the perfect choice for the Halloween season or any themed gothic party. This macabre masterpiece combines the art of mixology with a hauntingly unique design, sure to send shivers down your spine. The glass, which stands at 4.3\" tall, offers a perfect balance of elegance and eeriness, and it can hold up to 10 ounces of your favorite liquor.\nWhat sets the Skeleton Whiskey Glass apart is its stem, which takes the form of a bony, skeletal hand. Crafted with meticulous attention to detail, the hand's bones are intricately carved to mimic the anatomy of a human hand, complete with finger joints and knuckles. This spine-tingling design element not only adds a captivating visual dimension to the glass but also serves as a functional and secure grip for your whiskey-drinking experience.",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:45.887Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
